import { render, staticRenderFns } from "./ActiveCampaignsCard.vue?vue&type=template&id=8bbf8b28&scoped=true"
import script from "./ActiveCampaignsCard.vue?vue&type=script&lang=js"
export * from "./ActiveCampaignsCard.vue?vue&type=script&lang=js"
import style0 from "./ActiveCampaignsCard.vue?vue&type=style&index=0&id=8bbf8b28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bbf8b28",
  null
  
)

export default component.exports